<template>
  <div class="card is-min-width-700">
    <header class="bandeau-modal card-header">
    </header>
    <div class="card-content">
      <section class="has-text-centered pdb-40px">
        <p class="is-size-3 has-text-weight-bold">
          {{ $t('societes.codeGeneratorDispositif.title') }}
        </p>
      </section>
      <b-field
        :label="$t('societes.codeGeneratorDispositif.code')">
        <b-input v-model="code" ref="codeInput"/>
      </b-field>
      <div class="columns is-multiline mgb-20px">
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="code += '{CODE_EMPLACEMENT}'">
            {CODE_EMPLACEMENT}
          </p>
          <p class="has-text-default">
            {{ $t('societes.codeGeneratorDispositif.paramCodeDispositif.codeEmplacement') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="code += '{INSEE}'">
            {INSEE}
          </p>
          <p class="has-text-default">
            {{ $t('societes.codeGeneratorDispositif.paramCodeDispositif.insee') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="code += '{CODE_POSTAL}'">
            {CODE_POSTAL}
          </p>
          <p class="has-text-default">
            {{ $t('societes.codeGeneratorDispositif.paramCodeDispositif.codePostal') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="code += '{CODIFICATION_DISPOSITIF}'">
            {CODIFICATION_DISPOSITIF}
          </p>
          <p class="has-text-default">
            {{ $t('societes.codeGeneratorDispositif.paramCodeDispositif.codificationDispositif') }}
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="code += '{XXX}'">
            {XXX}
          </p>
          <p class="has-text-default">
            {{ $t('societes.codeGeneratorDispositif.paramCodeDispositif.sequence') }}<br>
            <span class="is-italic is-size-7">
              {{ $t('societes.messageInfo')}} </span>
          </p>
        </div>
        <div class="column is-6">
          <p class="has-text-weight-bold is-cursor-pointer"
             @click="code += '{ABC}'">
            {ABC}
          </p>
          <p class="has-text-default">
            {{ $t('societes.codeGeneratorDispositif.paramCodeDispositif.sequenceAlpha') }}
          </p>
        </div>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel') }}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="save()">
              {{ $t('general.button.edit') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    value: {
      type: String,
    },
  },
  data() {
    return {
      code: null,
    };
  },
  methods: {
    save() {
      this.$emit('updateCodeDispositifGenerator', this.code);
      this.$parent.close();
    },
  },
  mounted() {
    this.$refs.codeInput.focus();
    this.code = this.value ? this.value : '';
  },
};
</script>
